<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("movieRateCard", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $t("manageMovieRateCardHere") }}
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getMovieDetailList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <div class="desg-list-container">
      <div class="desg-list-header">
        <div class="ml-5">
          {{ $t("movieName") }}
        </div>
      </div>
      <div class="data-body" v-if="movieDetailList.length > 0">
        <div
          class="data-row border-bottom"
          v-for="(item, key) in movieDetailList"
          :key="key"
        >
          <div class="row p-1">
            <div class="col text-left">
              <div class="d-flex align-items-center lh-25">
                <StatusDot
                  class="m-1"
                  :status="
                    item.MainRateCardArray.length > 0 ? 'active' : 'inactive'
                  "
                />
                <button
                  v-if="!item.collapse"
                  class="btn-transparent togglePlusMinusBtn"
                  v-b-toggle="'moreDetails-' + key"
                  v-b-tooltip="'MoreDetails'"
                  tabindex="0"
                >
                  +
                </button>
                <button
                  v-if="item.collapse"
                  class="btn-transparent togglePlusMinusBtn"
                  v-b-toggle="'moreDetails-' + key"
                >
                  -
                </button>
                <div
                  v-if="$can('update', 'Movie Rate Card')"
                  class="edit-pen blue-icon btn"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                  @click="
                    goToRoute('/cinema-manager/edit-movie-rate-card', item)
                  "
                ></div>

                <span v-b-toggle="'moreDetails-' + key" class="w-100 ml-2">
                  {{ item.movie_title }}
                </span>
              </div>
            </div>

            <div
              class="col text-right mr-5"
              v-if="false"
              v-b-toggle="'moreDetails-' + key"
            >
              <div class="d-flex w-100 justify-content-end mr-5">
                <button class="btn-transparent">
                  <img
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
                <StatusDot
                  class="m-1"
                  :status="
                    item.MainRateCardArray.length > 0 ? 'active' : 'inactive'
                  "
                />
              </div>
            </div>
          </div>

          <b-collapse
            v-model="item.collapse"
            :id="'moreDetails-' + key"
            class="movie-license-collapse m-2"
          >
            <table class="list-view-table mb-0">
              <thead>
                <tr>
                  <th>{{ "Cinema" }}</th>
                  <th>{{ "Screen" }}</th>
                  <th>{{ "Seat Type" }}</th>
                  <th>{{ "From Date" }}</th>
                  <th>{{ "To Date" }}</th>
                  <th>{{ "Time" }}</th>
                  <th>{{ "Rate Card" }}</th>
                  <th>{{ "Private Rate Card" }}</th>
                </tr>
              </thead>
              <template
                v-if="
                  item.MainRateCardArray && item.MainRateCardArray.length > 0
                "
              >
                <tbody>
                  <tr
                    v-for="(mrc, mrcIndex) in item.MainRateCardArray"
                    :key="mrcIndex"
                  >
                    <td>{{ mrc.cine_name }}</td>
                    <td>{{ mrc.screen_name }}</td>
                    <td>{{ mrc.sst_seat_type }}</td>
                    <td>{{ mrc.from_date | dateFormat }}</td>
                    <td>{{ mrc.to_date | dateFormat }}</td>
                    <td>
                      {{ mrc.start_date_time + " - " + mrc.end_date_time }}
                    </td>
                    <td>{{ mrc.rc_g_name }}</td>
                    <td>{{ mrc.rc_gp_name }}</td>
                  </tr>
                </tbody>
              </template>
              <tbody v-else>
                <td colspan="6">
                  <NoRecords />
                </td>
              </tbody>
            </table>
          </b-collapse>
        </div>
      </div>

      <div class="pb-3" v-else>
        <NoRecords classes="mb-0" />
      </div>
    </div>

    <table class="list-view-table" v-if="listView && false">
      <thead>
        <tr>
          <th>
            {{ $t("Movie Name") }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $t("action") }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="movieDetailList.length > 0">
        <tr v-for="(item, key) in movieDetailList" :key="key">
          <td>{{ item.movie_title }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end mr-4">
              <div
                class="edit-pen blue-icon ml-3 btn"
                @click="goToRoute('/cinema-manager/edit-movie-rate-card', item)"
              ></div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="movieDetailList.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="movieDetailList.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchType: "All",
      searchKey: "mf_name",
      movieDetailList: [],
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.getMovieDetailList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getMovieDetailList() {
      this.movieDetailList = [];
      let payload = {
        currentPage: this.currentPage,
        limit: this.perPage,
        search: this.searchValue,
        searchType: this.searchType,
        show_rc_data: true,
      };
      CinemasService.GetMovieDetailList(payload)
        .then((response) => {
          const { data } = response;
          console.log(data);
          if (data && data.status && data.Records.hasOwnProperty("data")) {
            if (data.Records.data.length > 0) {
              data.Records.data.forEach((x) => {
                x["collapse"] = false;
              });
              this.movieDetailList = data.Records.data;
              console.log(this.movieDetailList);
              if (data.Records.pagination.hasOwnProperty("total")) {
                if (data.Records.pagination.total >= 10) {
                  this.rows = data.Records.pagination.total;
                } else {
                  this.rows = data.Records.pagination.total;
                  this.selectedvalue = data.Records.pagination.total;
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieDetailList();
      } else {
        this.currentPage = event;
        this.getMovieDetailList();
      }
    },
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { md_id } = item;
      this.$router.push({
        path: path,
        query: {
          md_id: md_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getMovieDetailList();
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style>
.movie-license-collapse {
  background-color: #e6e6f8;
  padding: 10px 10px;
}
.lh-25 {
  line-height: 25px;
}
.togglePlusMinusBtn {
  color: #3876d2;
  font-size: 30px;
  font-weight: 500;
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MovieRateCard/movieRateCards.vue